<template>
  <b-modal v-model="showModal" hide-header hide-footer centered>
    <p class="font-weight-bold f-size-20 text-header mb-2">Select Page</p>
    <div class="pt-3" v-if="pages.length > 0">
      <b-form-group>
        <b-form-radio
          v-model="selectedPage"
          v-for="(page, pageIndex) in pages"
          :key="pageIndex"
          name="page-fb"
          :value="page"
          class="mb-3 radio-page-fb"
        >
          <img :src="page.picture.data.url" class="mr-1" />{{
            page.name
          }}</b-form-radio
        >
      </b-form-group>
    </div>
    <div v-else class="text-center py-3">
      <span>No Page</span>
    </div>
    <div class="mb-3" v-if="v && v.$error">
      <span class="text-danger" v-if="v.id.required == false">Please Select Page</span>
    </div>
    <div class="d-flex justify-content-between">
      <button
        :disabled="isLoading"
        class="cancel-button"
        @click="onCloseModal()"
      >
        Cancel
      </button>
      <button :disabled="isLoading" class="save-button" @click="confirm(selectedPage)">
        Confrim
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalSelectPageFacebook",
  data: function() {
    return {
      selectedPage: {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null
          },
        },
        id: ""
      },
      showModal: false,
      isLoading: false
    };
  },
  props: {
    pages: {
      required: false,
      type: Array,
    },
    v: {
      required: false,
      type: Object,
    },
  },
  methods: {
    setDefaultData(){
      this.selectedPage = {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null
          },
        },
        id: ""
      }
    },
    onCloseModal() {
      this.showModal = false;
    },
    onShowModal () {
      this.setDefaultData();
      this.showModal = true;
    },
    async confirm(selectedPage) {
      this.$emit("handleSelectedPage", selectedPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-20 {
  font-size: 20px;
}

.f-size-18 {
  font-size: 18px;
}

.text-header {
  color: #242424;
}

.text-title {
  color: #575757;
}

.errorClass > .dropdown-setting-date {
  border-color: red !important;
}
.cancel-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #ffffff;
  color: #8f20c6 !important;
  border-radius: 4px;
  border: 1px solid #8f20c6;
  min-width: 30%;
}
.save-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #8f20c6;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
  min-width: 30%;
}
::v-deep .radio-page-fb {
  label {
    cursor: pointer;
  }
  > input[type=radio],
  .custom-control-label::before,
  .custom-control-label::after {
    top: 16px;
  }
}
</style>
